import { apiRequest } from '@/lib/api'

export type InstitutionForgotPasswordInput = {
  email: string
  reset_url: string
}

export type InstitutionResetPasswordInput = {
  email: string
  token: string
  password: string
  password_confirmation: string
}

export async function institutionForgotPassword(
  input: InstitutionForgotPasswordInput
): Promise<{ success: boolean; message?: string }> {
  return apiRequest<{ success: boolean; message?: string }>('/api/institution/password/forgot', {
    method: 'POST',
    body: input,
  })
}

export async function institutionResetPassword(
  input: InstitutionResetPasswordInput
): Promise<{ success: boolean; message?: string }> {
  return apiRequest<{ success: boolean; message?: string }>('/api/institution/password/reset', {
    method: 'POST',
    body: input,
  })
}

export function buildInstitutionPasswordResetUrl(): string {
  if (typeof window === 'undefined') {
    return '/redefinir-senha'
  }

  return `${window.location.origin}/redefinir-senha`
}
